(() => {
  document.querySelectorAll('.diana-header').forEach((header) => {
    const toggle = header.querySelector('.diana-menu-toggle');
    if (!toggle) return;

    const closeMenu = () => {
      header.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Abrir menú y buscador');
      header.querySelectorAll('.diana-nav-item[open]').forEach((item) => item.removeAttribute('open'));
    };

    toggle.addEventListener('click', () => {
      const willOpen = !header.classList.contains('is-open');
      header.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', String(willOpen));
      toggle.setAttribute('aria-label', willOpen ? 'Cerrar menú y buscador' : 'Abrir menú y buscador');
    });

    header.querySelectorAll('.diana-nav a').forEach((link) => link.addEventListener('click', closeMenu));
    header.querySelectorAll('.diana-nav-item').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        header.querySelectorAll('.diana-nav-item[open]').forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });
    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) closeMenu();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });
  });

  document.querySelectorAll('[data-catalog-disclosure]').forEach((disclosure) => {
    disclosure.querySelectorAll('.diana-catalog-sidebar__nav').forEach((nav) => {
      const links = [...nav.children].sort((a, b) =>
        a.querySelector('span').textContent.localeCompare(b.querySelector('span').textContent, 'es', { sensitivity: 'base', numeric: true })
      );
      nav.append(...links);
    });
    const desktop = window.matchMedia('(min-width: 961px)');
    const syncDisclosure = () => { disclosure.open = desktop.matches; };
    syncDisclosure();
    desktop.addEventListener('change', syncDisclosure);
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  const initializeProductGallery = (gallery) => {
    if (gallery.dataset.galleryInitialized === 'true') return;
    gallery.dataset.galleryInitialized = 'true';

    const stage = gallery.querySelector('[data-gallery-stage]');
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-thumbnail]')];
    const previous = gallery.querySelector('[data-gallery-previous]');
    const next = gallery.querySelector('[data-gallery-next]');
    const counter = gallery.querySelector('[data-gallery-counter]');
    const dialog = gallery.querySelector('[data-gallery-dialog]');
    const dialogImage = gallery.querySelector('[data-gallery-dialog-image]');
    const dialogCounter = gallery.querySelector('[data-gallery-dialog-counter]');
    const dialogPrevious = gallery.querySelector('[data-gallery-dialog-previous]');
    const dialogNext = gallery.querySelector('[data-gallery-dialog-next]');
    const dialogClose = gallery.querySelector('[data-gallery-dialog-close]');
    const magnify = gallery.querySelector('[data-gallery-magnify]');
    const pan = gallery.querySelector('[data-gallery-pan]');
    let enlarged = false;
    let drag = null;
    dialogImage?.addEventListener('load', () => { if (magnify) magnify.disabled = false; });
    dialogImage?.addEventListener('error', () => { if (magnify) magnify.disabled = true; });
    const resetMagnification = () => {
      enlarged = false;
      pan?.classList.remove('is-enlarged');
      if (dialogImage) dialogImage.style.width = '';
      if (pan) pan.scrollTo(0, 0);
      if (magnify) {
        magnify.setAttribute('aria-pressed', 'false');
        magnify.setAttribute('aria-label', 'Acercar imagen');
        magnify.title = 'Acercar imagen';
        magnify.querySelector('[data-magnify-in]').hidden = false;
        magnify.querySelector('[data-magnify-out]').hidden = true;
      }
    };
    magnify?.addEventListener('click', () => {
      if (enlarged) { resetMagnification(); return; }
      if (!dialogImage?.complete || !dialogImage.naturalWidth || !pan) return;
      const fit = Math.min(pan.clientWidth, pan.clientHeight * dialogImage.naturalWidth / dialogImage.naturalHeight);
      enlarged = true;
      pan.classList.add('is-enlarged');
      dialogImage.style.width = `${Math.max(fit, Math.min(dialogImage.naturalWidth, fit * 3))}px`;
      magnify.setAttribute('aria-pressed', 'true');
      magnify.setAttribute('aria-label', 'Alejar imagen');
      magnify.title = 'Alejar imagen';
      magnify.querySelector('[data-magnify-in]').hidden = true;
      magnify.querySelector('[data-magnify-out]').hidden = false;
    });
    pan?.addEventListener('pointerdown', (event) => {
      if (!enlarged || event.pointerType !== 'mouse' || event.button !== 0) return;
      event.preventDefault();
      drag = { x: event.clientX, y: event.clientY, left: pan.scrollLeft, top: pan.scrollTop };
      pan.setPointerCapture(event.pointerId);
    });
    pan?.addEventListener('pointermove', (event) => {
      if (!drag) return;
      pan.scrollLeft = drag.left + drag.x - event.clientX;
      pan.scrollTop = drag.top + drag.y - event.clientY;
    });
    pan?.addEventListener('lostpointercapture', () => { drag = null; });
    let currentIndex = 0;
    let touchStartX = null;
    let touchStartY = null;

    if (!stage || slides.length === 0) return;

    const normalizeIndex = (index) => (index + slides.length) % slides.length;

    const syncDialogImage = () => {
      if (!dialogImage) return false;
      resetMagnification();
      const zoom = slides[currentIndex].querySelector('[data-gallery-zoom]');
      if (!zoom) return false;
      if (magnify) magnify.disabled = true;
      dialogImage.src = zoom.dataset.galleryFull;
      if (magnify && dialogImage.complete && dialogImage.naturalWidth) magnify.disabled = false;
      dialogImage.alt = zoom.dataset.galleryAlt || '';
      if (dialogCounter) dialogCounter.textContent = `${currentIndex + 1} / ${slides.length}`;
      return true;
    };

    const showSlide = (index, focusThumbnail = false) => {
      currentIndex = normalizeIndex(index);
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === currentIndex;
        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);
      });
      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const isActive = thumbnailIndex === currentIndex;
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-selected', String(isActive));
        if (isActive) {
          const strip = thumbnail.parentElement;
          const thumbnailLeft = thumbnail.offsetLeft;
          const thumbnailRight = thumbnailLeft + thumbnail.offsetWidth;
          if (strip && thumbnailLeft < strip.scrollLeft) {
            strip.scrollTo({ left: thumbnailLeft, behavior: 'smooth' });
          } else if (strip && thumbnailRight > strip.scrollLeft + strip.clientWidth) {
            strip.scrollTo({ left: thumbnailRight - strip.clientWidth, behavior: 'smooth' });
          }
          if (focusThumbnail) thumbnail.focus();
        }
      });
      if (counter) counter.textContent = `${currentIndex + 1} / ${slides.length}`;
      if (dialog?.open) syncDialogImage();

      const nextImage = slides[normalizeIndex(currentIndex + 1)].querySelector('img');
      if (nextImage?.loading === 'lazy') nextImage.loading = 'eager';
    };

    const stepToImage = (direction) => {
      let candidate = currentIndex;
      for (let attempt = 0; attempt < slides.length; attempt += 1) {
        candidate = normalizeIndex(candidate + direction);
        if (slides[candidate].querySelector('[data-gallery-zoom]')) {
          showSlide(candidate);
          return;
        }
      }
    };

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => showSlide(Number(thumbnail.dataset.galleryIndex)));
      thumbnail.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showSlide(currentIndex - 1, true);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          showSlide(currentIndex + 1, true);
        }
      });
    });

    previous?.addEventListener('click', () => showSlide(currentIndex - 1));
    next?.addEventListener('click', () => showSlide(currentIndex + 1));

    stage.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showSlide(currentIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showSlide(currentIndex + 1);
      }
    });

    stage.addEventListener('touchstart', (event) => {
      touchStartX = event.touches.length === 1 ? event.touches[0].clientX : null;
      touchStartY = event.touches.length === 1 ? event.touches[0].clientY : null;
    }, { passive: true });
    stage.addEventListener('touchend', (event) => {
      if (touchStartX === null || event.changedTouches.length !== 1) return;
      const distance = event.changedTouches[0].clientX - touchStartX;
      const verticalDistance = event.changedTouches[0].clientY - touchStartY;
      touchStartX = null;
      touchStartY = null;
      if (Math.abs(distance) < 45 || Math.abs(verticalDistance) >= Math.abs(distance)) return;
      showSlide(currentIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });

    gallery.querySelectorAll('[data-gallery-zoom]').forEach((zoom) => {
      zoom.addEventListener('click', () => {
        currentIndex = Number(zoom.closest('[data-gallery-slide]').dataset.galleryIndex);
        showSlide(currentIndex);
        if (!dialog || !syncDialogImage()) return;
        if (typeof dialog.showModal === 'function') dialog.showModal();
      });
    });

    dialogPrevious?.addEventListener('click', () => stepToImage(-1));
    dialogNext?.addEventListener('click', () => stepToImage(1));
    dialogClose?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('close', () => {
      resetMagnification();
      slides[currentIndex]?.querySelector('[data-gallery-zoom]')?.focus();
    });
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog?.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        const buttons = [...dialog.querySelectorAll('button:not(:disabled)')].filter(button => button.getClientRects().length);
        const first = buttons[0];
        const last = buttons[buttons.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        stepToImage(-1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        stepToImage(1);
      }
    });

    showSlide(0);
  };

  document.querySelectorAll('[data-product-gallery]').forEach(initializeProductGallery);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-product-gallery]').forEach(initializeProductGallery);
  });

  document.querySelectorAll('[data-coverage-url]').forEach((coverageSection) => {
    const form = coverageSection.querySelector('[data-coverage-form]');
    const result = coverageSection.querySelector('[data-coverage-result]');
    const input = form?.querySelector('input[name="postal_code"]');
    if (!form || !result || !input) return;

    let coveragePromise;
    const getCoverage = () => {
      if (!coveragePromise) {
        coveragePromise = fetch(coverageSection.dataset.coverageUrl, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error('No se pudo cargar la cobertura');
            return response.json();
          }).catch((error) => {
            coveragePromise = undefined;
            throw error;
          });
      }
      return coveragePromise;
    };

    const showResult = (type, heading, message) => {
      result.className = `diana-coverage-result diana-coverage-result--${type}`;
      result.replaceChildren();
      const strong = document.createElement('strong');
      const paragraph = document.createElement('p');
      strong.textContent = heading;
      paragraph.textContent = message;
      result.append(strong, paragraph);
    };

    input.addEventListener('input', () => {
      input.value = input.value.replace(/\D/g, '').slice(0, 5);
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const postalCode = input.value.trim();
      if (!/^\d{5}$/.test(postalCode)) {
        showResult('error', 'Revisa el código postal', 'Debe contener exactamente cinco dígitos.');
        return;
      }

      result.className = 'diana-coverage-result';
      result.textContent = 'Consultando cobertura…';

      try {
        const coverage = await getCoverage();
        const zone = coverage[postalCode];
        if (!zone) {
          showResult('outside', 'Aún no aparece como zona participante', 'Contáctanos para revisar una alternativa de entrega o retiro en bodega.');
          return;
        }

        showResult(
          'covered',
          'Sí tenemos envío gratuito',
          `${zone.municipality}, ${zone.state}. Plazo estimado: ${zone.min} a ${zone.max} días hábiles.`
        );
      } catch (error) {
        showResult('error', 'No fue posible consultar ahora', 'Inténtalo nuevamente o comunícate con nosotros para confirmar la cobertura.');
      }
    });
  });
})();
